// The two tabs of the offer-linked result screen's segmented control.
export type ResultTab = "ricerca" | "pool";

// Default tab on entry (AC2) and the fold-to target for any missing/invalid value.
export const RESULT_TAB_DEFAULT: ResultTab = "ricerca";

const VALID_TABS: ReadonlySet<string> = new Set<ResultTab>(["ricerca", "pool"]);

/**
 * Normalizes the raw `?tab=` URL value to a valid {@link ResultTab}. Missing,
 * empty, unknown, or wrong-case values fold to {@link RESULT_TAB_DEFAULT}
 * ("ricerca") so a stale or hand-typed URL never lands on an undefined tab.
 * Tolerates a `string[]` (router can hand back arrays) by taking the first entry.
 */
export const normalizeResultTab = (
  raw: string | string[] | undefined,
): ResultTab => {
  const value = Array.isArray(raw) ? raw[0] : raw;
  return value && VALID_TABS.has(value)
    ? (value as ResultTab)
    : RESULT_TAB_DEFAULT;
};

/**
 * The tabs appear ⟺ the search is offer-linked: `researchType === "from_offer"`
 * AND a truthy `job_offer_id`. Independent of the plan (AC1 / decision log) — the
 * plan only decides what the pool tab renders, never whether the tabs exist.
 */
export const shouldShowResultTabs = (
  researchType: string | null | undefined,
  jobOfferId: string | null | undefined,
): boolean => researchType === "from_offer" && !!jobOfferId;
